import React, { Component } from 'react';
import PayMustaqbalReceipt from '../components/Remittance/PayMustaqbalReceipt';
import { setGlobalLoading, getMustaqbalRemittanceReportData } from '../services/ReportService';
import Loader from "../components/Loader";

export default class PayMustaqbalRemittanceReceipt extends Component {

  constructor(){
    super();
    this.language = 'en';
    var count = window.location.pathname.split('/').length; 
    this.tid = window.location.pathname.split('/')[2];
    this.isReprintData = false;
    this.showSignature = false;

    var queryParams = new URLSearchParams(window.location.search);

    if (queryParams.get('v') == 1) {
      this.isReprintData = true;
    }

    if(queryParams.get('s') == 1) {
      this.showSignature = true;
    }

    this.state = { reportData: null, loading: false };
  }
  componentDidMount() {
    setGlobalLoading((loading) => this.setState({ loading }));

    getMustaqbalRemittanceReportData(this.tid, this.language).then((res) => {
      this.setState({reportData : res.data});
    });
  }
  render() {
    return (
      <div>
         {this.state.loading && <Loader />}
        {this.state.reportData ? (
          <div>
            <PayMustaqbalReceipt
              result={this.state.reportData}
              isBankCopy={false}
              isReprint={this.isReprintData}
              showSignature={this.showSignature}
            />
            <PayMustaqbalReceipt
              result={this.state.reportData}
              isBankCopy={true}
              isReprint={this.isReprintData}
              showSignature={this.showSignature}
            />
          </div>
        ) : null}
      </div>
    );
  }
}
